"use client";

/**
 * perf(forge 2026-09-11): below-fold lazy boundary (same pattern as the
 * sibling governli/cerebras optimizations). Reserves a mobile height until the
 * placeholder nears the viewport (rootMargin 1200px => the swap happens
 * off-screen, no CLS), so heavy client-only sections (recharts) never load in
 * the initial script set.
 */
import { useEffect, useRef, useState, type ReactNode } from "react";

export function LazyOnVisible({
  minHeight = 0,
  children,
}: {
  minHeight?: number;
  children: ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { setShow(true); return; }
    const io = new IntersectionObserver(
      (es) => { if (es.some((e) => e.isIntersecting)) { setShow(true); io.disconnect(); } },
      { rootMargin: "1200px 0px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} style={show ? undefined : { minHeight }}>
      {show ? children : null}
    </div>
  );
}
